// extracted by mini-css-extract-plugin
export var badge = "CourtesyHoldEcommerceBenefits-module--badge--6b7a6";
export var badgeIcon = "CourtesyHoldEcommerceBenefits-module--badge-icon--56586";
export var box = "CourtesyHoldEcommerceBenefits-module--box--7750b";
export var button = "CourtesyHoldEcommerceBenefits-module--button--249e8";
export var content = "CourtesyHoldEcommerceBenefits-module--content--d367e";
export var contentContainer = "CourtesyHoldEcommerceBenefits-module--content-container--654e8";
export var days = "CourtesyHoldEcommerceBenefits-module--days--c8a1b";
export var title = "CourtesyHoldEcommerceBenefits-module--title--611eb";